import React from 'react';
import PropTypes from 'prop-types';

class SelfServeBuilderPageCanvas extends React.PureComponent {

  constructor(props) {
    super(props);

    this.renderPage = this.renderPage.bind(this);
    this.renderTask = null;

    this.setCanvasRef = this.setCanvasRef.bind(this);
  }

  componentDidMount() {
    this.renderPage();
  }

  componentDidUpdate() {
    if (this.renderTask) {
      return;
    }
    this.renderPage();
  }

  setCanvasRef(node) {
    this.canvas = node;
  }

  async renderPage() {
    const { page, scale } = this.props;
    if (this.renderTask) {
      this.renderTask.cancel();
    }
    try {
      this.renderTask = page.render({ canvasContext: this.canvas.getContext('2d'), viewport: page.getViewport(scale) });
      await this.renderTask.promise;
      this.renderTask = null;
    } catch (err) {
      window.Raven.captureException(err);
      this.renderTask = null;
    }
  }

  render() {
    return (
      <canvas
        height={this.props.height}
        ref={this.setCanvasRef}
        width={this.props.width}
      />
    );
  }
}

SelfServeBuilderPageCanvas.propTypes = {
  height: PropTypes.number.isRequired,
  page: PropTypes.shape().isRequired,
  scale: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
};

export default SelfServeBuilderPageCanvas;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilder/SelfServeBuilderPageCanvas.jsx